// extracted by mini-css-extract-plugin
export default {"hidden":"RecommendedReleases__hidden--QssnG","releaseListContainer":"RecommendedReleases__releaseListContainer--vhvE7"};